import React from 'react'

const HomeContact = () => {
    const pageHandler =()=>{
        window.location.href = "/contact";
    }
  return (
    <section className="home-contact-section">
      <div className="home-contact-div">
        <h2 className="home-contact-heading">Need a Fitness Trainer?</h2>
        <h3 className="home-contact-subheading">
          <span className="highlight-text">Call : </span>
          +91 12345 67890
        </h3>
        <button className="home-contact-button" onClick={pageHandler}>Send Message</button>
      </div>
    </section>
  )
}

export default HomeContact;